import React from 'react';

import { isString } from 'lodash';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { LoginModal, MEDIA_QUERIES } from '@sm360/widget-commons-general';

import ProfileForm from 'login/components/Profile/ProfileForm/ProfileForm.jsx';
import ChangePasswordForm from 'login/components/Profile/ChangePasswordForm/ChangePasswordForm.jsx';
import MediaQuery from 'react-responsive';

import TokenService from 'login/services/TokenService/TokenService.js';
import { PROFILE as MODAL } from 'login/constants/modalNames.js';

import 'login/components/Profile/ProfileModal.scss';

const czGroupName = 'widget.login.forms.profile';

class ProfileModal extends React.Component {
    renderWithClassUtil(classParam) {
        const headerTitle =
            ContentZonesService.getContentZone(czGroupName, 'maintext') &&
            ContentZonesService.getContentZone(czGroupName, 'maintext').getValue();
        const headerText =
            ContentZonesService.getContentZone(czGroupName, 'subtext') &&
            ContentZonesService.getContentZone(czGroupName, 'subtext').getValue();
        const password = TokenService.isFacebookToken() || <ChangePasswordForm />;

        const classUtil = isString(classParam) ? classParam : '';
        return (
            <div className={`ProfileForm is-scrollable ${classUtil}`}>
                <div className="profile-header">
                    <h1 className="sr-title-1" dangerouslySetInnerHTML={{ __html: headerTitle }} />
                    <div className="sr-text">{headerText}</div>
                </div>

                <ProfileForm />

                {password}
            </div>
        );
    }

    render() {
        const imageUrl =
            ContentZonesService.getContentZone(czGroupName, 'image') &&
            ContentZonesService.getContentZone(czGroupName, 'image').getValue();
        return (
            <LoginModal
                name={MODAL}
                contentLabel="dialog with form for user profile"
                className="widget-profile-popupElement"
                bckGrndImage={`url(${imageUrl})`}
            >
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>{this.renderWithClassUtil('is-scrollable')}</MediaQuery>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>{this.renderWithClassUtil()}</MediaQuery>
            </LoginModal>
        );
    }
}

ProfileModal.displayName = 'ProfileModal';

export default ProfileModal;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileModal.jsx